import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";

import actions from "@/actions";
import { Toastr } from "@/components";

const emptyMessage = {};

/**
 * Connects Redux window messages to a Toastr notification for a given context.
 *
 * @param root0 - The component props.
 * @param root0.context - The message context to subscribe to.
 * @returns The rendered message display component.
 */
const MessageDisplay = ({ context }) => {
    const dispatch = useDispatch();
    const { message, type } = useSelector(
        ({ window }) => window.messages[context] ?? emptyMessage,
    );

    return (
        <Toastr
            message={message}
            onClose={() => dispatch(actions.window.hideMessage(context))}
            active={!!message}
            type={type}
        />
    );
};
MessageDisplay.propTypes = {
    context: PropTypes.string,
};

export default MessageDisplay;
